import React, { useEffect, useState } from "react";
import { getNewsInner } from "../Service/Api";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const News = () => {
  const [newsData, setNewsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getNewsInner();
        setNewsData(data || []);
        console.log("Fetched News:", data);
      } catch (error) {
        console.error("Failed to fetch news:", error);
        setNewsData([]);
      }
    };
    fetchData();
  }, []);

  const fallbackNews = [
    {
      title: "Stay Tuned for Latest Updates",
      description: "Datesheet for Class IX and XI (Annual Exams)",
      date: "07-May-2025",
    },
    {
      title: "Stay Tuned for Latest Updates",
      description: "Datesheet for Class IX and XI (Annual Exams)",
      date: "07-May-2025",
    },
    {
      title: "Stay Tuned for Latest Updates",
      description: "Datesheet for Class IX and XI (Annual Exams)",
      date: "07-May-2025",
    },
  ];

  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 3,
    centerPadding: "40px",
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: 2 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="newsbg">
      <Slider {...settings}>
        {(newsData.length > 0 ? newsData : fallbackNews).map((item, index) => (
          <div className="item" key={item._id || index}>
            <div className="news">
              <h4>{item?.title || "No Title"}</h4>
              <p>{item?.description || "No Description Available"}</p>
              {/* Attachments (if any) */}
              {item?.attachments?.length > 0 && item.attachments[0] && (
                <div className="attch">
                  <a
                    href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Click Here <i className="bi bi-paperclip"></i>
                  </a>
                </div>
              )}

              <p className="date">
                {item?.fromDate
                  ? new Date(item.fromDate).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                  : item?.date || "Date not available"}
              </p>


            </div>

            {/* Arrow button link */}
            <div className="arrow-button">
              <Link to="/News">
                <i className="bi bi-arrow-right"></i>
              </Link>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default News;
